import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'; // For persisting state to localStorage

interface UserProfile {
  id: string;
  username: string;
  roles?: string[];
  // Add any other user data you want to store (e.g., company_id from Odoo)
  company_id?: number;
}

interface AuthState {
  token: string | null;
  user: UserProfile | null;
  isAuthenticated: boolean;
  _hasHydrated: boolean;

  login: (token: string, user: UserProfile) => void;
  logout: () => void;
  setToken: (token: string | null) => void; // Added for initial token setting
  setHasHydrated: (state: boolean) => void;
}

// Create the Zustand store with persistence
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      _hasHydrated: false,
      login: (token, user) => set({ token, user, isAuthenticated: true }),
      logout: () => set({ token: null, user: null, isAuthenticated: false }),
      setToken: (token) => set({ token, isAuthenticated: !!token }), // Set isAuthenticated based on token presence
      setHasHydrated: (state) => set({ _hasHydrated: state }),
    }),
    {
      name: 'auth-storage', // unique name for localStorage key
      storage: createJSONStorage(() => localStorage), // Use localStorage
      onRehydrateStorage: (state) => {
        console.log('hydration starts'); // Optional: for debugging
        return (state, error) => {
          if (error) {
            console.error('hydration error', error);
          } else {
            console.log('hydration finished'); // Optional: for debugging
            // IMPORTANT: Set _hasHydrated to true after rehydration
            if (state) { // Ensure state exists before calling its method
              state.setHasHydrated(true);
            }
          }
        };
      },
      // Optionally, you can choose which parts of the state to persist
      partialize: (state) => {
          return ({ token: state.token, user: state.user, isAuthenticated: state.isAuthenticated });
      },
    },
  ),
);